export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLightItalic-Latin2-6ee4a22faeb490b97321c40130fa56a4.woff";